<app-header></app-header>
<ng-progress id="progressBar" [fixed]="false" [meteor]="false" [spinner]="false" color="#f53331" [speed]="200" [trickleSpeed]="300"> </ng-progress>
<app-header-overlay></app-header-overlay>
<main role="main">
  <router-outlet></router-outlet>
</main>
<app-search-suggests-overlay></app-search-suggests-overlay>
